"use client";

import Link from 'next/link';
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';

import "swiper/css";
import { Autoplay, Navigation } from 'swiper/modules';
import urls from '@/utils/urls/urls';

export default function ProductsLatest({ products }: { products: any }) {
    return (
        <>
            <Swiper className="mySwiper d-flex justify-content-between gap-4 bg-white"

                slidesPerView={4}
                spaceBetween={30}
                modules={[Autoplay, Navigation]}
                navigation={{
                    prevEl: ".destination-card2-prev",
                    nextEl: ".destination-card2-next",
                }}
                // breakpoints={{
                //     320: { slidesPerView: 1, spaceBetween: 10 },
                //     640: { slidesPerView: 2, spaceBetween: 20 },
                //     1024: { slidesPerView: 3, spaceBetween: 30 }
                // }}

                loop={true}
                style={{
                    // border: "1px solid red",
                    borderRadius: "30px",
                    padding: "0 20px",
                    // height: "450px",
                }}
            >
                {
                    products?.map((prod: any, index: number) => <SwiperSlide className="portfolio-item" key={index}>
                        <div className="portfolio-img"
                           
                        >
                            <img

                                className="img-fluid100 service-img"
                                // src="/assets/img/portfolio/jersey.png"
                                src={urls?.image + prod.image}
                                alt=""
                            />
                            <Link
                                className="popup-img portfolio-link"
                                // href="../assets/img/portfolio/jersey.png"
                                href={urls?.image + prod.image}
                            >
                                {" "}
                                <i className="far fa-plus" />
                            </Link>
                        </div>
                        <div className="portfolio-content">
                            <div className="portfolio-info">
                                {/* <small>Power</small> */}
                                {/* <small>
                                    <Link href={`/products/${prod?.id}`}>{prod?.category?.name}</Link>
                                </small> */}
                                <h4>
                                    <Link href={`/products/${prod?.id}`}>{prod?.name}</Link>
                                </h4>
                            </div>
                            <Link href={`/products/${prod?.id}`} className="portfolio-arrow">
                                <i className="fas fa-arrow-right" />
                            </Link>
                        </div>
                    </SwiperSlide>)
                }
                {/* <SwiperSlide className="portfolio-item">
                    <div className="portfolio-img">
                        <img

                            className="img-fluid100"
                            src="/assets/img/portfolio/jersey.png"
                            alt=""
                        />
                        <Link
                            className="popup-img portfolio-link"
                            href="../assets/img/portfolio/jersey.png"
                        >
                            {" "}
                            <i className="far fa-plus" />
                        </Link>
                    </div>
                    <div className="portfolio-content">
                        <div className="portfolio-info">
                            <small>Power</small>
                            <h4>
                                <Link href="/products/1">Single Jersey</Link>
                            </h4>
                        </div>
                        <Link href="/products/1" className="portfolio-arrow">
                            <i className="fas fa-arrow-right" />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide className="portfolio-item">
                    <div className="portfolio-img">
                        <img

                            className="img-fluid100"
                            src="/assets/img/portfolio/fleece.png"
                            alt=""
                        />
                        <Link
                            className="popup-img portfolio-link"
                            href="../assets/img/portfolio/fleece.png"
                        >
                            {" "}
                            <i className="far fa-plus" />
                        </Link>
                    </div>
                    <div className="portfolio-content">
                        <div className="portfolio-info">
                            <small>Power</small>
                            <h4>
                                <Link href="/products/2">Three-End Fleece</Link>
                            </h4>
                        </div>
                        <Link href="/products/2" className="portfolio-arrow">
                            <i className="fas fa-arrow-right" />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide className="portfolio-item">
                    <div className="portfolio-img">
                        <img

                            className="img-fluid100"
                            src="/assets/img/portfolio/highspeedrib.png"
                            alt=""
                        />
                        <Link
                            className="popup-img portfolio-link"
                            href="../assets/img/portfolio/highspeedrib.png"
                        >
                            {" "}
                            <i className="far fa-plus" />
                        </Link>
                    </div>
                    <div className="portfolio-content">
                        <div className="portfolio-info">
                            <small>Power</small>
                            <h4>
                                <Link href="/products/3">High-Speed Rib</Link>
                            </h4>
                        </div>
                        <Link href="/products/3" className="portfolio-arrow">
                            <i className="fas fa-arrow-right" />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide className="portfolio-item">
                    <div className="portfolio-img">
                        <img

                            className="img-fluid100"
                            src="/assets/img/portfolio/smalljersey.png"
                            alt=""
                        />
                        <Link
                            className="popup-img portfolio-link"
                            href="../assets/img/portfolio/smalljersey.png"
                        >
                            {" "}
                            <i className="far fa-plus" />
                        </Link>
                    </div>
                    <div className="portfolio-content">
                        <div className="portfolio-info">
                            <small>Power</small>
                            <h4>
                                <Link href="/products/5">Small Diameter Jersey Machines</Link>
                            </h4>
                        </div>
                        <Link href="/products/5" className="portfolio-arrow">
                            <i className="fas fa-arrow-right" />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide className="portfolio-item">
                    <div className="portfolio-img">
                        <img

                            className="img-fluid100"
                            src="/assets/img/portfolio/ow.png"
                            alt=""
                        />
                        <Link
                            className="popup-img portfolio-link"
                            href="../assets/img/portfolio/ow.png"
                        >
                            {" "}
                            <i className="far fa-plus" />
                        </Link>
                    </div>
                    <div className="portfolio-content">
                        <div className="portfolio-info">
                            <small>Power</small>
                            <h4>
                                <Link href="/products/4">Open-Width</Link>
                            </h4>
                        </div>
                        <Link href="/products/4" className="portfolio-arrow">
                            <i className="fas fa-arrow-right" />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide className="portfolio-item">
                    <div className="portfolio-img">
                        <img

                            className="img-fluid100"
                            src="/assets/img/portfolio/smallrib.png"
                            alt=""
                        />
                        <Link
                            className="popup-img portfolio-link"
                            href="../assets/img/portfolio/smallrib.png"
                        >
                            {" "}
                            <i className="far fa-plus" />
                        </Link>
                    </div>
                    <div className="portfolio-content">
                        <div className="portfolio-info">
                            <small>Power</small>
                            <h4>
                                <Link href="/products/6">Small Diameter Rib Machines</Link>
                            </h4>
                        </div>
                        <Link href="/products/6" className="portfolio-arrow">
                            <i className="fas fa-arrow-right" />
                        </Link>
                    </div>
                </SwiperSlide> */}
                {/* <SwiperSlide className="portfolio-item">
                    <div className="portfolio-img">
                        <img
                            className="img-fluid100"
                            src="../assets/img/portfolio/highspeedrib.jpg"
                            alt=""
                        />
                        <Link
                            className="popup-img portfolio-link"
                            href="../assets/img/portfolio/22.jpg"
                        >
                            {" "}
                            <i className="far fa-plus" />
                        </Link>
                    </div>
                    <div className="portfolio-content">
                        <div className="portfolio-info">
                            <small>Mechine Power</small>
                            <h4>
                                <Link href="/products/123">Textile Mechine</Link>
                            </h4>
                        </div>
                        <Link href="/products/123" className="portfolio-arrow">
                            <i className="fas fa-arrow-right" />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide className="portfolio-item">
                    <div className="portfolio-img">
                        <img
                            className="img-fluid100"
                            src="../assets/img/portfolio/33.jpg"
                            alt=""
                        />
                        <Link
                            className="popup-img portfolio-link"
                            href="../assets/img/portfolio/33.jpg"
                        >
                            {" "}
                            <i className="far fa-plus" />
                        </Link>
                    </div>
                    <div className="portfolio-content">
                        <div className="portfolio-info">
                            <small>Installation</small>
                            <h4>
                                <Link href="/products/123">Mechine Installation</Link>
                            </h4>
                        </div>
                        <Link href="/products/123" className="portfolio-arrow">
                            <i className="fas fa-arrow-right" />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide className="portfolio-item">
                    <div className="portfolio-img">
                        <img
                            className="img-fluid100"
                            src="../assets/img/portfolio/44.jpg"
                            alt=""
                        />
                        <Link
                            className="popup-img portfolio-link"
                            href="../assets/img/portfolio/44.jpg"
                        >
                            {" "}
                            <i className="far fa-plus" />
                        </Link>
                    </div>
                    <div className="portfolio-content">
                        <div className="portfolio-info">
                            <small>Energy</small>
                            <h4>
                                <Link href="/products/123">Hydraulic Energy</Link>
                            </h4>
                        </div>
                        <Link href="/products/123" className="portfolio-arrow">
                            <i className="fas fa-arrow-right" />
                        </Link>
                    </div>
                </SwiperSlide>
                <SwiperSlide className="portfolio-item">
                    <div className="portfolio-img">
                        <img
                            className="img-fluid100"
                            src="../assets/img/portfolio/44.jpg"
                            alt=""
                        />
                        <Link
                            className="popup-img portfolio-link"
                            href="../assets/img/portfolio/44.jpg"
                        >
                            {" "}
                            <i className="far fa-plus" />
                        </Link>
                    </div>
                    <div className="portfolio-content">
                        <div className="portfolio-info">
                            <small>Energy</small>
                            <h4>
                                <Link href="/products/123">Hydraulic Energy</Link>
                            </h4>
                        </div>
                        <Link href="/products/123" className="portfolio-arrow">
                            <i className="fas fa-arrow-right" />
                        </Link>
                    </div>
                </SwiperSlide> */}
                {/* <div className="portfolio-item">
                    <div className="portfolio-img">
                      <img
                        className="img-fluid100"
                        src="../assets/img/portfolio/55.jpg"
                        alt=""
                      />
                      <Link
                        className="popup-img portfolio-link"
                        href="../assets/img/portfolio/55.jpg"
                      >
                        {" "}
                        <i className="far fa-plus" />
                      </Link>
                    </div>
                    <div className="portfolio-content">
                      <div className="portfolio-info">
                        <small>Maintenance</small>
                        <h4>
                          <Link href="/products/123">Mechine Maintenance</Link>
                        </h4>
                      </div>
                      <Link href="/products/123" className="portfolio-arrow">
                        <i className="fas fa-arrow-right" />
                      </Link>
                    </div>
                  </div> */}
            </Swiper>
        </>
    )
}
